module.exports = __webpack_public_path__ + "static/media/marriageArticle3.cac5116f.jpg";